/* ============================================================
   Collection budget filtering — by ACTUAL product price (cents),
   not tags and not compare-at price. All products render with a
   data-price; pills filter client-side with a JS "load more".
   Bands (cents): under RM100 = <10000, RM100-200 = 10000..20000,
   over RM200 = >20000. Active band persists in ?budget= for sort/share.
   ============================================================ */
(function () {
  'use strict';
  var grid = document.querySelector('[data-rds-grid]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.rds-pcard'));
  var pills = Array.prototype.slice.call(document.querySelectorAll('[data-rds-band]'));
  var countEl = document.querySelector('[data-rds-count]');
  var moreCount = document.querySelector('[data-rds-more-count]');
  var loadMore = document.querySelector('[data-rds-loadmore]');

  var BANDS = { under: [0, 9999], mid: [10000, 20000], over: [20001, Infinity] };
  var PAGE = 24;
  var band = null;
  var limit = PAGE;

  function priceOf(c) { return parseInt(c.getAttribute('data-price'), 10) || 0; }
  function inBand(c, b) { var r = BANDS[b]; var p = priceOf(c); return p >= r[0] && p <= r[1]; }
  function matches(c) { return !band || inBand(c, band); }

  function render() {
    var shown = 0, total = 0;
    cards.forEach(function (c) {
      if (matches(c)) {
        total++;
        if (shown < limit) { c.style.display = ''; shown++; } else { c.style.display = 'none'; }
      } else {
        c.style.display = 'none';
      }
    });
    if (countEl) countEl.textContent = total + (total === 1 ? ' product' : ' products');
    if (moreCount) moreCount.textContent = 'Showing ' + shown + ' of ' + total + ' bunches';
    if (loadMore) loadMore.style.display = shown < total ? '' : 'none';
    pills.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-rds-band') === band); });
  }

  // hide pills for bands that have no products in this collection
  pills.forEach(function (p) {
    var b = p.getAttribute('data-rds-band');
    if (!cards.some(function (c) { return inBand(c, b); })) p.style.display = 'none';
  });

  function setBand(b) {
    band = (band === b) ? null : b; // toggle off if re-clicked
    limit = PAGE;
    render();
    var u = new URL(window.location.href);
    if (band) u.searchParams.set('budget', band); else u.searchParams.delete('budget');
    history.replaceState({}, '', u);
  }

  pills.forEach(function (p) {
    p.addEventListener('click', function () { setBand(p.getAttribute('data-rds-band')); });
  });
  if (loadMore) loadMore.addEventListener('click', function () { limit += PAGE; render(); });

  // sort dropdown: carry the active band through the reload
  var sortSel = document.querySelector('.rds-coll__select select');
  if (sortSel) {
    sortSel.onchange = function () {
      var v = this.value;
      if (band) v += (v.indexOf('?') > -1 ? '&' : '?') + 'budget=' + band;
      window.location.href = v;
    };
  }

  // initialise from URL (so sort/refresh/share keep the filter)
  var initial = new URL(window.location.href).searchParams.get('budget');
  if (initial && BANDS[initial]) band = initial;
  render();
})();
